var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermissionYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 100",
    d: "M18.5798 9C18.5798 13.8332 14.6743 17.75 9.85824 17.75C5.04222 17.75 1.13672 13.8332 1.13672 9C1.13672 4.16676 5.04222 0.25 9.85824 0.25C14.6743 0.25 18.5798 4.16676 18.5798 9Z",
    fill: "#FCE670",
    fillOpacity: 0.26,
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Orange"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 38764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 120",
    d: "M5.69357 12.9614L4.60678 7.86647C4.58984 7.78707 4.66958 7.72165 4.74414 7.75377L7.74572 9.04666C7.79417 9.06753 7.8505 9.04718 7.87442 9.00016L9.8473 5.12166C9.883 5.05146 9.98207 5.04817 10.0224 5.11584L12.3369 9.00338C12.3638 9.04862 12.4212 9.06523 12.4682 9.04135L14.968 7.76972C15.0421 7.73203 15.1272 7.79596 15.1116 7.87762L14.1404 12.9593C14.1314 13.0064 14.0902 13.0405 14.0422 13.0405H5.79137C5.74418 13.0405 5.70341 13.0075 5.69357 12.9614Z",
    fill: "#FFCF26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 121",
    d: "M5.69357 12.9609L4.60688 7.86651C4.58993 7.78702 4.66986 7.72158 4.74444 7.7539L7.06913 8.76113C7.09864 8.77392 7.1202 8.80012 7.12707 8.83155L8.0198 12.9187C8.03342 12.9811 7.98593 13.04 7.9221 13.04H5.79137C5.74418 13.04 5.70341 13.0071 5.69357 12.9609Z",
    fill: "#F7E481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 122",
    d: "M5.16118 10.5773L4.60459 7.86295C4.58841 7.78408 4.66732 7.71941 4.74148 7.75075L5.85249 8.22032C5.88227 8.23291 5.90413 8.25912 5.91116 8.29069L6.41126 10.5355C6.42518 10.5979 6.37765 10.6572 6.31365 10.6572H5.25914C5.21166 10.6572 5.17072 10.6238 5.16118 10.5773Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 120_2",
    d: "M5.69357 12.9614L4.60678 7.86647C4.58984 7.78707 4.66958 7.72165 4.74414 7.75377L7.74572 9.04666C7.79417 9.06753 7.8505 9.04718 7.87442 9.00016L9.8473 5.12166C9.883 5.05146 9.98207 5.04817 10.0224 5.11584L12.3369 9.00338C12.3638 9.04862 12.4212 9.06523 12.4682 9.04135L14.968 7.76972C15.0421 7.73203 15.1272 7.79596 15.1116 7.87762L14.1404 12.9593C14.1314 13.0064 14.0902 13.0405 14.0422 13.0405H5.79137C5.74418 13.0405 5.70341 13.0075 5.69357 12.9614Z",
    stroke: "black",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionYellow);
export default __webpack_public_path__ + "static/media/permissionYellow.060dc174837bf2f278ae0070a7dedc57.svg";
export { ForwardRef as ReactComponent };